import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "Prénom",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "Entrez votre prénom."
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "Nom",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "Entrez votre nom."
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "Numéro de telephone",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "Entrez un numéro de téléphone correct.",
    "Entrez un numéro de téléphone correct."
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "Numéro de téléphone secondaire",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "Entrez un numéro de téléphone correct."
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "Adresse de livraison, ligne 1",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "Entrez votre adresse."
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "Adresse de livraison, ligne 2",
  "size": 100,
  "model": "address2"
},
{
  "id": "city",
  "type": "input",
  "label": "Ville",
  "size": 50,
  "model": "city"
},
{
  "id": "state",
  "type": "input",
  "label": "Région",
  "size": 50,
  "model": "state"
},
{
  "id": "postal-code",
  "type": "input",
  "label": "Code postal",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "Entrez un code postal correct."
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "Pays/Région",
  "size": 50,
  "model": "countryName"
}
]